
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/tools/seo-friendly-url-generator",
      function () {
        return require("private-next-pages/app/tools/seo-friendly-url-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/tools/seo-friendly-url-generator"])
      });
    }
  